module.exports = __webpack_public_path__ + "static/media/CEL-ETH.43231fce.png";